export type WiserThemeTokens = {
  pageBg: string;
  surface: string;
  surfaceStrong: string;
  surfaceMuted: string;
  textPrimary: string;
  textSecondary: string;
  textMuted: string;
  border: string;
  borderStrong: string;
  headerText: string;
  inputBg: string;
  hoverBg: string;
  navHoverBg: string;
  accent: string;
  ctaPrimary: string;
  link: string;
  sidebarBg: string;
  sidebarText: string;
  sidebarIcon: string;
  tableHeaderBg: string;
  tableRowHover: string;
  surfaceShadow: string;
};

/** v2 ile uyumlu dark body gradient */
export const WISER_DARK_BODY_GRADIENT = [
  "radial-gradient(circle at 0% 100%, rgba(240, 133, 45, 0.16), transparent 28%)",
  "radial-gradient(circle at 90% 10%, rgba(46, 88, 166, 0.22), transparent 35%)",
  "linear-gradient(145deg, #0f1a2e 0%, #1a2b48 58%, #0d1628 100%)",
].join(", ");

const light: WiserThemeTokens = {
  pageBg: "#f4f5f8",
  surface: "#ffffff",
  surfaceStrong: "#ffffff",
  surfaceMuted: "#fafbfc",
  textPrimary: "#172b4d",
  textSecondary: "#42526e",
  textMuted: "#6b778c",
  border: "#dfe1e6",
  borderStrong: "#c1c7d0",
  headerText: "#ffffff",
  inputBg: "#ffffff",
  hoverBg: "#f4f5f7",
  navHoverBg: "#f4f5f7",
  accent: "#374e7d",
  ctaPrimary: "#374e7d",
  link: "#0052cc",
  sidebarBg: "#374e7d0d",
  sidebarText: "#344563",
  sidebarIcon: "#3b4863",
  tableHeaderBg: "#ffffff",
  tableRowHover: "#f4f5f7",
  surfaceShadow: "0px 2px 8px rgba(16, 24, 40, 0.10)",
};

/** RDCBoard v2 dark — navy panel, turuncu CTA, mavi border */
const dark: WiserThemeTokens = {
  pageBg: "#0f1a2e",
  surface: "rgba(26, 43, 72, 0.88)",
  surfaceStrong: "rgba(15, 26, 46, 0.94)",
  surfaceMuted: "rgba(36, 56, 88, 0.74)",
  textPrimary: "#e2e8f0",
  textSecondary: "#a6b8cd",
  textMuted: "#7389a8",
  border: "rgba(64, 156, 209, 0.26)",
  borderStrong: "rgba(64, 156, 209, 0.4)",
  headerText: "#ffffff",
  inputBg: "rgba(36, 56, 88, 0.74)",
  hoverBg: "rgba(64, 156, 209, 0.08)",
  navHoverBg: "rgba(46, 88, 166, 0.2)",
  accent: "#409cd1",
  ctaPrimary: "#f0852d",
  link: "#409cd1",
  sidebarBg: "rgba(15, 26, 46, 0.95)",
  sidebarText: "#a6b8cd",
  sidebarIcon: "#7389a8",
  tableHeaderBg: "rgba(0, 0, 0, 0.18)",
  tableRowHover: "rgba(64, 156, 209, 0.08)",
  surfaceShadow: "0 16px 28px rgba(2, 8, 20, 0.42)",
};

export const getWiserTheme = (darkModeActive: boolean): WiserThemeTokens =>
  darkModeActive ? dark : light;

export const WISER_THEME_STORAGE_KEY = "mode";

export type PaginationTheme = {
  textPrimary: string;
  textSecondary: string;
  surface: string;
  border: string;
  hoverBg: string;
  activeBg: string;
  activeText: string;
  focusBorder: string;
};

export const getPaginationTheme = (
  darkModeActive: boolean,
): PaginationTheme => {
  const t = getWiserTheme(darkModeActive);
  return {
    textPrimary: t.textPrimary,
    textSecondary: t.textSecondary,
    surface: t.surface,
    border: t.border,
    hoverBg: t.hoverBg,
    activeBg: darkModeActive ? "#2e58a6" : "#172B4D",
    activeText: "#FFFFFF",
    focusBorder: darkModeActive ? t.accent : "#0052CC",
  };
};
